import { render } from "./TeachersModal.vue?vue&type=template&id=bc4f8de8&scoped=true"
import script from "./TeachersModal.vue?vue&type=script&lang=js"
export * from "./TeachersModal.vue?vue&type=script&lang=js"

import "./TeachersModal.vue?vue&type=style&index=0&id=bc4f8de8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4f8de8"]])

export default __exports__